import { render, staticRenderFns } from "./SetStatusFlow.vue?vue&type=template&id=a0563998&"
import script from "./SetStatusFlow.vue?vue&type=script&lang=js&"
export * from "./SetStatusFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0563998')) {
      api.createRecord('a0563998', component.options)
    } else {
      api.reload('a0563998', component.options)
    }
    module.hot.accept("./SetStatusFlow.vue?vue&type=template&id=a0563998&", function () {
      api.rerender('a0563998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/SetStatusFlow.vue"
export default component.exports